import { useEffect } from "react";

const SITE = "https://vyrti.com";
const DEFAULT_IMAGE = `${SITE}/og-image.jpg`;

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Per-page SEO: updates title, description, canonical, OG/Twitter tags and JSON-LD.
export function useSeo({ title, description, path, image, type = "website", jsonLd } = {}) {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    if (!title) return;
    document.title = title;
    upsertMeta("property", "og:title", title);
    upsertMeta("name", "twitter:title", title);
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    const url = `${SITE}${path || window.location.pathname}`;
    upsertMeta("property", "og:url", url);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = url;
    upsertMeta("property", "og:type", type);
    const img = image || DEFAULT_IMAGE;
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:image", img);
    let script = document.getElementById("seo-jsonld");
    if (jsonLdStr) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "seo-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = jsonLdStr;
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, image, type, jsonLdStr]);
}
